import { ChangeEvent, useState } from 'react';
import dealershipDomains from '~/constants/dealership/dealershipDomains';
import { isLocalEnvironment } from '~/constants/environment';
import { useIsNative } from '~/context/common/DeviceContext';
import FormField from './FormField';
import {
  Button as StyledButton,
  Container,
  Heading,
  Select,
  Text
} from './PassengerTools.styles';

const subdomain = isLocalEnvironment ? 'localhost' : 'test';

export default function Dealerships() {
  const [selectedDomain, setSelectedDomain] = useState(
    Object.keys(dealershipDomains).at(0)
  );
  const isNative = useIsNative();

  const handleGoToDealership = () => {
    if (isNative || !selectedDomain) return;

    window.location.href = `https://${subdomain}.${selectedDomain}/cars`;
  };

  return (
    <Container>
      <Heading>Select Dealership</Heading>
      <Text>Navigate to the search page of a specific dealership.</Text>
      <FormField label="Dealership" htmlFor="dealership-select">
        <Select
          id="dealership-select"
          value={selectedDomain}
          onChange={(e: ChangeEvent<HTMLSelectElement>) =>
            setSelectedDomain(e.target.value)
          }
        >
          {Object.entries(dealershipDomains).map(([domain, city]) => (
            <option key={domain} value={domain}>
              {city}
            </option>
          ))}
        </Select>
      </FormField>

      <div className="flex justify-end">
        <StyledButton
          type="button"
          onClick={handleGoToDealership}
          data-analytics-id={null}
          data-testid="go-to-search-page"
        >
          Go to Search Page
        </StyledButton>
      </div>
    </Container>
  );
}
